<template>
	<div>
		<CModal
			:show.sync="isShow"
			:close-on-backdrop="false"
			class="modal-static-widget"
			centered
		>
			<template #header-wrapper>
				<ModalHeaderWrapper
					:title="title"
					@onClose="close"
				/>
			</template>
			<template #default>
				<CForm @submit.prevent="handleSubmit">
					<CRow>
						<CCol col="12">
							<CInput
								ref="widget-name"
								v-model.trim="$v.form.name.$model"
								:is-valid="!$v.form.name.$error && null"
								invalid-feedback="Widget name is required"
								label="Widget name *"
							/>
						</CCol>
					</CRow>
					<CRow>
						<CCol col="6">
							<CInput
								v-model.trim="form.titleEN"
								label="Title EN (optional)"
							/>
						</CCol>
						<CCol col="6">
							<CInput
								v-model.trim="form.titleTH"
								label="Title TH (optional)"
							/>
						</CCol>
					</CRow>
					<CRow>
						<CCol lg="12">
							<CRow>
								<CCol col="12" class="d-flex pr-0">
									<CCol col="6" class="pl-0">
										<label class="toggle-label" for="widget-visibility">
											Website visibility
										</label>
									</CCol>
									<CCol col="6" class="pl-0">
										<label class="toggle-label" for="widget-visibility">
											Mobile visibility
										</label>
									</CCol>
								</CCol>
								<CCol col="12" class="d-flex pr-0">
									<CCol col="6" class="d-flex align-items-center pl-0">
										<CSwitch
											id="widget-visibility"
											:checked="form.websiteVisibility.value === 'on'"
											variant="3d"
											size="sm"
											class="mr-3"
											color="success"
											@update:checked="val => form.websiteVisibility = val ? WIDGET_VISIBILITY.true : WIDGET_VISIBILITY.false"
										/>
										<span>{{ form.websiteVisibility.name }}</span>
									</CCol>
									<CCol col="6" class="d-flex align-items-center pl-0">
										<CSwitch
											id="widget-visibility"
											:checked="form.mobileVisibility.value === 'on'"
											variant="3d"
											size="sm"
											class="mr-3"
											color="success"
											@update:checked="val => form.mobileVisibility = val ? WIDGET_VISIBILITY.true : WIDGET_VISIBILITY.false"
										/>
										<span>{{ form.mobileVisibility.name }}</span>
									</CCol>
								</CCol>
							</CRow>
						</CCol>
					</CRow>
					<CRow class="mt-3">
						<CCol col="4">
							Display product price
						</CCol>
						<CCol col="8" class="d-flex">
							<CSwitch
								id="display-product-price"
								:checked.sync="form.displayPriceType"
								variant="3d"
								size="sm"
								class="mr-3"
								color="success"
							/>
							<span>{{ productDisplayPriceText }}</span>
						</CCol>
					</CRow>
					<hr class="my-4">
					<CRow>
						<CCol col="12" class="d-flex mb-3">
							<span>Display button</span>
							<CSwitch
								id="display-button"
								:checked.sync="form.displayButton"
								variant="3d"
								size="sm"
								class="ml-3"
								color="success"
							/>
						</CCol>
						<CCol col="6">
							<CInput
								v-model.trim="form.buttonNameEN"
								label="Button Name EN (optional)"
							/>
						</CCol>
						<CCol col="6">
							<CInput
								v-model.trim="form.buttonNameTH"
								label="Button Name TH (optional)"
							/>
						</CCol>
						<CCol col="12" class="position-description">
							<span class="typo-caption-2">No name assign to the button. The default button name is "View More"</span>
						</CCol>
					</CRow>
					<div class="mt-3">
						<CCol col="12" class="pl-0">
							<CInput
								v-model.trim="$v.form.widgetLink.$model"
								:is-valid="!$v.form.widgetLink.$error && null"
								:invalid-feedback="$t('global.error.url')"
								label="URL Link (optional)"
							/>
							<div class="typo-caption-2 position-description">No URL Link assigned. The default link is the markeing link.</div>
						</CCol>
					</div>
				</CForm>
			</template>
			<template #footer>
				<a
					v-if="isEdit"
					href="#"
					class="btn-remove mr-auto w-100"
					@click="$emit('onRemove')"
				>
					Remove widget
				</a>
				<BaseModalFooter
					:disabled-confirm="disabledConfirm"
					@onCancel="close"
					@onConfirm="handleSubmit"
				/>
			</template>
		</CModal>
	</div>
</template>


<script>
import { mapState } from 'vuex';
import { required, url } from 'vuelidate/lib/validators';
import ModalHeaderWrapper from '@/components/ModalHeaderWrapper.vue';
import BaseModalFooter from '@/components/BaseModalFooter.vue';
import { WIDGET_TYPE, WIDGET_VISIBILITY } from '../../enums/widgets';
import { PRODUCT_DISPLAY_PRICE_TYPE } from '../../enums/widgetProduct';

export default {
	name: 'ModalProductWidget',
	components: {
		ModalHeaderWrapper,
		BaseModalFooter,
	},
	data() {
		return {
			WIDGET_VISIBILITY,
			isShow: false,
			title: 'Create Product widget',
			isEdit: false,
			form: {
				name: '',
				titleEN: '',
				titleTH: '',
				displayPriceType: false,
				displayButton: true,
				buttonNameEN: '',
				buttonNameTH: '',
				widgetLink: '',
				websiteVisibility: WIDGET_VISIBILITY.true,
				mobileVisibility: WIDGET_VISIBILITY.true,
			},
		};
	},
	validations: {
		form: {
			name: {
				required,
			},
			widgetLink: {
				url,
			},
		},
	},
	computed: {
		...mapState('pages', {
			create: 'createWidget',
			edit: 'editWidget',
		}),
		disabledConfirm() {
			return this.$v.$invalid || (this.isEdit && this.edit.isLoading) || this.create.isLoading;
		},
		productDisplayPriceText() {
			return this.form.displayPriceType ? PRODUCT_DISPLAY_PRICE_TYPE.INSTALLMENT : PRODUCT_DISPLAY_PRICE_TYPE.PRICE;
		},
	},
	methods: {
		async open(data = null) {
			this.isShow = true;
			this.setFormData(data);
			await this.$nextTick();
			const inputElement = this.$refs['widget-name']?.$el?.querySelector('input');
			if (inputElement) {
				inputElement.focus();
			}
		},
		close() {
			this.$v.$reset();
			this.isShow = false;
		},
		setFormData(data) {
			this.isEdit = Boolean(data);
			this.title = data ? 'Edit Product widget' : 'Create Product widget';
			this.form.name = data?.name ?? '';
			this.form.titleEN = data?.titleEN ?? data?.['title_en'] ?? '';
			this.form.titleTH = data?.titleTH ?? data?.['title_th'] ?? '';
			this.form.displayPriceType = (data?.sellingType ?? data?.['selling_type']) === PRODUCT_DISPLAY_PRICE_TYPE.INSTALLMENT;
			this.form.displayButton = data?.displayButton ?? data?.['is_display_button'] ?? true;
			this.form.buttonNameEN = data?.buttonNameEN ?? data?.['button_name_en'] ?? '';
			this.form.buttonNameTH = data?.buttonNameTH ?? data?.['button_name_th'] ?? '';
			this.form.widgetLink = data?.widgetLink ?? data?.['url_link'] ?? '';

			const isActive = data?.isActive ?? data?.['is_active'];
			this.form.websiteVisibility = isActive === 0 || isActive === false ? WIDGET_VISIBILITY.false : WIDGET_VISIBILITY.true;

			const isMobileActive = data?.isMobileActive ?? data?.['is_mobile_active'];
			this.form.mobileVisibility = isMobileActive === 0 || isMobileActive === false ? WIDGET_VISIBILITY.false : WIDGET_VISIBILITY.true;
		},
		handleSubmit() {
			if (this.$v.$invalid) {
				return;
			}
			this.form.type = WIDGET_TYPE.product;
			this.form.sellingType = this.form.displayPriceType ? PRODUCT_DISPLAY_PRICE_TYPE.INSTALLMENT : PRODUCT_DISPLAY_PRICE_TYPE.PRICE;
			this.$emit('onSubmit', this.form);
		},
	},
};
</script>
<style lang="scss" scoped>
::v-deep .modal-static-widget {
	.modal-footer {
		flex-wrap: unset !important;
	}
}

.position-description {
	margin-top: -15px;
}
</style>
